<template>
  <el-dialog
    title="高级搜索"
    :visible.sync="dialogVisible"
    width="40%"
    top="5vh"
    :close-on-click-modal="false"
    custom-class="search-dialog"
    @close="handleClose">
    <div class="search-dialog-content">
      <el-form class="form" :model="searchCondition" inline size="mini" @submit.native.prevent>
        <el-form-item label="负责人">
          <ProductLeaderSelect ref="refProductLeader" :leader-id.sync="searchCondition.leader_id"
                               class="w-full product-leader-select" @selected="handleLeaderSelected"
                               v-if="userPermissions.indexOf('product_view_all') > -1"/>
          <span v-else>{{ userInfo.nickname }}</span>
        </el-form-item>
        <el-form-item label="类目">
          <CategoryCascader ref="refCategoryCascader" :identify="identify" @cascaderChange="handleCascaderChange"
 class="category-cascader w-full"/>
        </el-form-item>

        <el-form-item label="商品名称">
          <el-input placeholder="商品名称" v-model="searchCondition.title" clearable/>
        </el-form-item>
        <el-form-item label="是否统一机制">
          <el-select clearable v-model="searchCondition.unify" placeholder="是否统一机制">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌">
          <template slot="label">
            <el-link @click.stop.native="handleRefreshBrand"><i
              :class="[loadingBrandStatus ? 'el-icon-loading' : 'el-icon-refresh']"></i>品牌
            </el-link>
          </template>
          <el-select clearable v-model="searchCondition.brand_id" filterable @focus="getBrand"
                     placeholder="请选择">
            <el-option v-for="item in brandOptions" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可播平台">
          <el-input placeholder="可播平台" v-model="searchCondition.platform_name" clearable/>
        </el-form-item>
        <el-form-item label="线上佣金">
          <el-select clearable v-model="searchCondition.online_cmn" filterable
                     placeholder="请选择">
            <el-option v-for="(item, key) in onlineCmnOptions" :key="key" :label="item.name" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="是否秒杀品">
          <el-select clearable v-model="searchCondition.is_sec_kill" placeholder="是否秒杀品">
            <el-option label="是" value="Y"/>
            <el-option label="否" value="N"/>
          </el-select>
        </el-form-item>

        <el-form-item label="季节性">
          <el-select clearable v-model="searchCondition.used_season" placeholder="季节性">
            <el-option label="春" value="春"></el-option>
            <el-option label="夏" value="夏"></el-option>
            <el-option label="秋" value="秋"></el-option>
            <el-option label="冬" value="冬"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品产地">
          <el-input placeholder="产品产地" v-model="searchCondition.origin_place" clearable/>
        </el-form-item>
        <el-form-item label="录入时间">
          <el-date-picker v-model="searchCondition.date_range" type="daterange" align="right" unlink-panels
                          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="价格区间">
          <el-select v-model="modePrice" placeholder="">
            <el-option key="price" label="日常价" value="price"></el-option>
            <el-option key="lb_price" label="直播价" value="lb_price"></el-option>
          </el-select>
          <el-input placeholder="最低价" v-model="price[0]" clearable/>
          <span style="width: 10%;display: inline-block">
            ~
          </span>

          <el-input placeholder="最高价" v-model="price[1]" clearable/>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">搜索</el-button>
      <el-button @click="handleReset">重置</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {mapGetters} from 'vuex'
import ProductLeaderSelect from '@/pages/lb/components/ProductLeaderSelect'
import CategoryCascader from '@/pages/category/components/CategoryCascader'

export default {
  name: 'ProductSearchDialog',
  components: {
    ProductLeaderSelect,
    CategoryCascader
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    searchCondition: {
      type: Object,
      default: () => ({})
    },
    modePrice: {
      type: String,
      default: 'price'
    },
    price: {
      type: Array,
      default: () => []
    },
    identify:{
      type:String,
      default:'product'
    }
  },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo']),
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  data() {
    return {
      loadingBrandStatus: false,
      brandOptions: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      onlineCmnOptions: [
        { value: '0~10', name: '0~10' },
        { value: '10~20', name: '10~20' },
        { value: '20~30', name: '20~30' },
        { value: '30~40', name: '30~30' },
        { value: '40~50', name: '40~50' },
        { value: '50~60', name: '50~60' },
        { value: '60以上', name: '60以上' }
      ]
    }
  },
  methods: {
    async getBrand(force) {
      this.loadingBrandStatus = true
      if (this.brandOptions.length === 0 || force) {
        try {
          const { options } = await this.$api.getBrandOptions()
          this.brandOptions = options
        } catch (error) {
          console.error('获取品牌列表失败:', error)
        } finally {
          this.loadingBrandStatus = false
        }
      }
    },

    handleRefreshBrand() {
      this.getBrand(true)
    },

    handleLeaderSelected(option) {
      this.$emit('leader-selected', option)
    },

    handleCascaderChange(v) {
      this.searchCondition.category_id = null
      this.searchCondition.category_ids = null
      if (v.length) {
        this.searchCondition.category_id = v[(v.length - 1)]
        this.searchCondition.category_ids = v
      }
      this.$emit('cascader-change', v)
    },

    handleConfirm() {
      this.$emit('confirm')
      this.dialogVisible = false
    },

    handleCancel() {
      this.dialogVisible = false
      this.$emit('cancel')
    },

    handleReset() {
      // 重置级联选择器
      if (this.$refs.refProductLeader) {
        this.$refs.refProductLeader.clear()
      }
      // 重置类目选择器
      if (this.$refs.refCategoryCascader) {
        this.$refs.refCategoryCascader.clear()
      }
      // 重置搜索条件 - 通过触发父组件的重置方法
      this.$emit('reset')
    },

    handleClose() {
      this.$emit('close')
    }
  },
  created() {
    this.getBrand()
  }
}
</script>

<style scoped>
/* 搜索弹窗样式优化 - 紧凑布局 */
.search-dialog .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
  padding: 16px 20px;
}

.search-dialog .search-dialog-content {
  padding: 0;
}

.search-dialog .search-dialog-content .form {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 12px;
  align-items: start;
}

.search-dialog .search-dialog-content .form .el-form-item {
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  min-height: 56px;
}

.search-dialog .search-dialog-content .form .el-form-item .el-form-item__label {
  width: auto;
  text-align: left;
  font-weight: 500;
  color: #606266;
  margin-bottom: 4px;
  line-height: 1.2;
  padding-bottom: 0;
  font-size: 13px;
}

.search-dialog .search-dialog-content .form .el-form-item .el-form-item__content {
  flex: 1;
  display: flex;
  align-items: center;
}

.search-dialog .search-dialog-content .form .el-form-item .el-form-item__content .el-input,
.search-dialog .search-dialog-content .form .el-form-item .el-form-item__content .el-select,
.search-dialog .search-dialog-content .form .el-form-item .el-form-item__content .el-date-editor {
  width: 100%;
}

/* 特殊处理价格范围表单项目 */
.search-dialog .search-dialog-content .form .el-form-item:has(.el-select + .el-input) {
  min-height: 56px;
}

.search-dialog .search-dialog-content .form .el-form-item:has(.el-select + .el-input) .el-form-item__content {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.search-dialog .search-dialog-content .form .el-form-item:has(.el-select + .el-input) .el-form-item__content .el-select {
  flex: 1;
  min-width: 0;
  width: 30%; /* 价格类型选择器占30% */
}

.search-dialog .search-dialog-content .form .el-form-item:has(.el-select + .el-input) .el-form-item__content .el-input {
  flex: 1;
  min-width: 0;
  width: 30%; /* 每个价格输入框占30% */
}

.search-dialog .search-dialog-content .form .el-form-item:has(.el-select + .el-input) .el-form-item__content span {
  color: #909399;
  font-size: 13px;
  flex-shrink: 0;
  white-space: nowrap;
  width: 10%; /* 分隔符占10% */
  text-align: center;
}

/* 确保类目和负责人组件宽度与其他输入框一致 */
.search-dialog .search-dialog-content .form .el-form-item:has(.category-cascader),
.search-dialog .search-dialog-content .form .el-form-item:has(.product-leader-select) {
  min-height: 56px;
}

.search-dialog .search-dialog-content .form .el-form-item:has(.category-cascader) .el-form-item__content,
.search-dialog .search-dialog-content .form .el-form-item:has(.product-leader-select) .el-form-item__content {
  width: 100%;
}

.search-dialog .search-dialog-content .form .el-form-item:has(.category-cascader) .el-form-item__content .category-cascader,
.search-dialog .search-dialog-content .form .el-form-item:has(.product-leader-select) .el-form-item__content .product-leader-select {
  width: 100%;
}

/* 品牌标签特殊处理 */
.search-dialog .search-dialog-content .form .el-form-item:has(.el-link) .el-form-item__label {
  display: flex;
  align-items: center;
  gap: 3px;
}

.search-dialog .search-dialog-content .form .el-form-item:has(.el-link) .el-form-item__label .el-link {
  font-weight: 500;
  font-size: 13px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .search-dialog .search-dialog-content .form {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 10px;
  }
}

@media (max-width: 768px) {
  .search-dialog {
    width: 95% !important;
    margin: 2vh auto !important;
  }

  .search-dialog .search-dialog-content .form {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .search-dialog .search-dialog-content .form .el-form-item {
    min-height: 52px;
  }
}

/* 弹窗底部按钮优化 */
.search-dialog .dialog-footer {
  text-align: center;
  padding: 16px 20px;
  border-top: 1px solid #ebeef5;
  background: #f8f9fa;
}

.search-dialog .dialog-footer .el-button {
  min-width: 90px;
  margin: 0 6px;
  border-radius: 3px;
  font-weight: 500;
  font-size: 13px;
  padding: 8px 16px;
}

.search-dialog .dialog-footer .el-button:first-child {
  margin-left: 0;
}

.search-dialog .dialog-footer .el-button:last-child {
  margin-right: 0;
}

/* 弹窗标题样式优化 */
.search-dialog .el-dialog__header {
  padding: 16px 20px 8px;
  border-bottom: 1px solid #ebeef5;
}

.search-dialog .el-dialog__title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

/* 滚动条样式优化 */
.search-dialog .el-dialog__body::-webkit-scrollbar {
  width: 4px;
}

.search-dialog .el-dialog__body::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 2px;
}

.search-dialog .el-dialog__body::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 2px;
}

.search-dialog .el-dialog__body::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

/* 紧凑布局额外优化 */
.search-dialog .el-dialog {
  border-radius: 6px;
}

.search-dialog .el-dialog__headerbtn {
  top: 14px;
  right: 16px;
}

.search-dialog .el-dialog__headerbtn .el-dialog__close {
  font-size: 16px;
}

::v-deep .el-form-item__label {
  text-align: left !important;
}
</style>
